<template>
  <div>
    <template v-if="parentNode && parentNode.children">
      <div v-for="node in parentNode.children" :key="String(node.key)">
        <dl-folder-accordion-component :node="node" @check="onCheck" />
      </div>
    </template>
  </div>
</template>

<script lang="ts" src="./dl-folder-node-component.ts"></script>

<style lang="scss" scoped>
@use './dl-folder-node-component.scss';
</style>
